<template>
  <b-container fluid>
    <b-row>
      <b-col id="reportConsoleLeftSide" lg="4" md="4" sm="12">
        <iq-card
          class-name="iq-card-block iq-card-stretch"
          body-class=""
          class="p-3"
          id="quickQuotePage"
        >
          <div class="row justify-content-left selectableCard mt-3">
            <div class="invalid-feedback col-sm-12" v-if="errors.reportId">
              {{ errors.reportId[0] }}
            </div>

            <div class="col-sm-6 mt-3">
              <div
                class="card text-center"
                @click="fnSelectReport(1)"
                :class="{ active: reportId == 1 }"
              >
                <div class="card-body">
                  <div class="fs-4000"><i class="lar la-file-image"></i></div>
                  <h4 class="card-text fw-500">
                    EOM Summary Settlement Report
                  </h4>
                </div>
              </div>
            </div>
            <div class="col-sm-6 mt-3">
              <div
                class="card text-center"
                @click="fnSelectReport(4)"
                :class="{ active: reportId == 4 }"
              >
                <div class="card-body">
                  <div class="fs-4000"><i class="lar la-file-image"></i></div>
                  <h4 class="card-text fw-500">EOM Management Report</h4>
                </div>
              </div>
            </div>
          </div>

          <b-row>
            <b-col
              lg="12"
              md="12"
              sm="12"
              v-if="reportId == 1 || reportId == 4"
              class="mt-3"
            >
              <label class="typo__label">Dealer/s</label>
              <multiselect
                v-model="dealers"
                tag-placeholder="Add this as new tag"
                placeholder="Search or add a dealer"
                label="name"
                track-by="id"
                :options="getDealerDropdown"
                :multiple="true"
                :taggable="true"
              >
              </multiselect>
            </b-col>

            <b-col lg="12" md="12" sm="12">
              <div class="d-flex">
                <div class="pr-2">
                  <label class="" for="noteOnOtherIncome">From date</label>
                  <datePicker
                    :editable="true"
                    value-type="YYYY-MM-DD"
                    format="DD-MM-YYYY"
                    placeholder="DD-MM-YYYY"
                    v-model="fromDate"
                  >
                  </datePicker>
                  <div class="invalid-feedback" v-if="errors.fromDate">
                    {{ errors.fromDate[0] }}
                  </div>
                </div>
                <div class="pl-2">
                  <label class="" for="noteOnOtherIncome">To date</label>
                  <datePicker
                    :editable="true"
                    format="DD-MM-YYYY"
                    placeholder="DD-MM-YYYY"
                    value-type="YYYY-MM-DD"
                    v-model="toDate"
                  >
                  </datePicker>
                  <div class="invalid-feedback" v-if="errors.toDate">
                    {{ errors.toDate[0] }}
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <div class="row">
            <div class="col-12 text-right mt-3">
              <button
                class="btn btn-primary btn-sm mr-2"
                v-if="reportId == 4"
                @click="fnGenerate()"
              >
                Generate
              </button>
              <button
                v-if="rptData.length && reportId == 4"
                class="btn btn-success btn-sm mr-2"
                @click="fnPrintCall()"
              >
                Print
              </button>
              <button
                v-if="reportId == 1"
                class="btn btn-success btn-sm mr-2"
                @click="fnDownloadVsaSettlement()"
              >
                Download
                <b-spinner small v-if="loading" class="mr-2"></b-spinner>
              </button>
            </div>
          </div>
        </iq-card>
      </b-col>

      <b-col id="reportConsoleRightSide" lg="8" md="8" sm="12">
        <div>
          <div v-if="reportId == 4 && rptData.length">
            <appVSAEOMManagementReport
              :prosData="rptData"
              :propsDealerIds="dealerIds"
              :propsFromDate="fromDate"
              :propsToDate="toDate"
              ref="reportVSAEOMManagement"
            ></appVSAEOMManagementReport>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import store from '../../../store/modules/base.module'
import datePicker from 'vue2-datepicker'
import appVSAEOMSummarySettlementReport from '../../../components/admin/reports/VSAEOMSummarySettlementReport.vue'
import appVSAEOMManagementReport from '../../../components/admin/reports/VSAEOMManagementReport.vue'
import * as reportService from '../../../services/report.service'
import * as messageService from '../../../services/message.service'

export default {
  name: 'Report',
  components: {
    datePicker,
    appVSAEOMSummarySettlementReport,
    appVSAEOMManagementReport
  },
  mounted() {},
  data() {
    return {
      errors: {},
      dealers: [],
      reportId: '',
      rptData: [],
      dealerIds: [],
      fromDate: '',
      toDate: '',
      loading: false
    }
  },
  computed: {
    ...mapGetters(['getDealerDropdown'])
  },
  methods: {
    ...mapActions(['fetchDealerDropdown', 'fetchReportInputs']),
    fnSelectReport(reportId) {
      this.rptData = []
      this.reportId = reportId
    },

    async fnGenerate() {
      if (this.reportId == 1 || this.reportId == 4) {
        let dealers = this.dealers
        let dealerIds = []

        if (Array.isArray(dealers)) {
          dealers.filter(function (item) {
            return dealerIds.push(item.id)
          })
          this.dealerIds = dealerIds
        } else if (!Array.isArray(dealers) && dealers) {
          this.dealerIds = [this.dealers.id]
        } else {
          this.dealerIds = ''
        }
      } else if (this.reportId == 2 || this.reportId == 3) {
        if (this.dealers && this.dealers.id) {
          this.dealerIds = [this.dealers.id]
        } else {
          this.dealerIds = ''
        }
      }

      try {
        let dataObj = {
          reportId: this.reportId,
          fromDate: this.fromDate,
          toDate: this.toDate,
          dealerIds: this.dealerIds
        }

        this.errors = {}

        const res = await reportService.getAllSettledReport(dataObj)
        this.rptData = res.data
        localStorage.setItem('dataObj', JSON.stringify(dataObj))
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'Data range',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'Data range',
              'Something wrong'
            )
            break
        }
      }
    },
    fnPrintCall() {
      if (this.reportId == 4) {
        const routeData = this.$router.resolve({
          name: 'VSAEOMManagementReportPrintAdmin'
        })
        window.open(routeData.href, '_blank')
      }
    },

    async fnDownloadVsaSettlement() {
      this.loading = true
      let dealers = this.dealers
      let dealerIds = []

      if (Array.isArray(dealers)) {
        dealers.filter(function (item) {
          return dealerIds.push(item.id)
        })
        this.dealerIds = dealerIds
      } else if (!Array.isArray(dealers) && dealers) {
        this.dealerIds = [this.dealers.id]
      } else {
        this.dealerIds = ''
      }

      try {
        let dataObj = {
          reportId: this.reportId,
          fromDate: this.fromDate,
          toDate: this.toDate,
          dealerIds: this.dealerIds
        }

        this.errors = {}
        const filePath = await reportService.createVsaSettlementExport(dataObj)

        //file name and path of the finance doc.
        let obj3 = {
          file_name: filePath.data
        }

        // Download from Export VSA EOM Settlement Report in temp folder
        window.open(`${store.state.serverPath}/` + filePath.data, '_blank')

        // Delete temp Export VSA EOM Settlement Report in temp folder
        await reportService.deleteTempVsaSettlementExport(obj3)

        this.loading = false
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'Data range',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'Data range',
              'Something wrong'
            )
            break
        }
        console.log(error.response)
        this.loading = false
      }
    }
  },
  created() {
    this.fetchDealerDropdown()
  }
}
</script>

<style>
.iq-card-body {
  flex: unset;
}
@page {
  /* size: A4 portrait;  */
  width: 210mm;
  height: 280mm;
  margin: 20px 20px 20px 20px;
  padding: 0;
}
@media print {
  body * {
    visibility: hidden;
  }
  #quickQuotePage {
    display: none !important;
  }
  #quickQuotePage2 {
    display: none !important;
  }
  #printMe,
  #printMe * {
    visibility: visible !important;
  }
  #printMe {
    position: absolute !important;
    left: 0px !important;
    top: 0px !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
  }
}
</style>
